<template>
    <div class="component__contact">
        <h2
            class="component__contact_title"
            v-if="title.length"
        >{{title}}</h2>
        <ul class="component__contact_list">
            <li
                class="component__contact_list_item"
                v-if="email"
            >
                <div class="columns is-inline-flex-touch is-vcentered">
                    <div class="column column--content is-narrow">
                        <div class="component__contact_list_item_icon">
                            <v-icon name="mail"/>
                        </div>
                    </div>
                    <div class="column">
                        <div class="component__contact_list_item_text">
                            <a
                                :href="`mailto:${email}`"
                            >{{email}}</a>
                        </div>
                    </div>
                </div>
            </li>
            <li
                class="component__contact_list_item"
                v-if="phone"
            >
                <div class="columns is-inline-flex-touch is-vcentered">
                    <div class="column is-narrow">
                        <div class="component__contact_list_item_icon">
                            <v-icon name="phone"/>
                        </div>
                    </div>
                    <div class="column">
                        <div class="component__contact_list_item_text">{{phone}}</div>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
  name: 'component-contact',
  props: {
    title: {
      type: String,
      default: ''
    },
    email: {
      type: String,
      default: ''
    },
    phone: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss">
    @import '~@/assets/scss/components/default/shared/componentcontact';
</style>
